



























































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import ChartLeft from './components/chart-left.vue';
import ChartRight from './components/chart-right.vue';
import { utilizationDetail, utilizationInfo } from '@/api/statistic-analysis/index';
import moment from 'moment';

@Component({
  name: 'ParkingUtilizationRate',
  components: {
    ParkingLotSearch,
    ChartLeft,
    ChartRight
  }
})
export default class AbnormalOperation extends Mixins(TableMixin, TableWidthMixin) {
  filterParam: any = {
    startTime: '',
    endTime: ''
  };
  selectParkIds: Array<string> = []; // 车场名称
  dimensions: string = '01';
  timeRangeType: String = '01'; // 选择的时间范围
  timeQuickButtons: any[] = [];
  customTime: any[] = []; // 自定义时间
  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  tableData: any[] = [];
  tableLoading: boolean = false;
  chartData: any[] = [];
  utilizationSum: string = '';
  dateSort: string = '01';
  utilizationSort: string = '01';
  get tableColums() {
    if (this.dimensions === '00') {
      return [
        {
          title: '序号',
          width: 120,
          customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
        },
        {
          title: '日期',
          dataIndex: 'reportDate',
          width: 180
        },
        {
          // title: '时段',
          dataIndex: 'reportTime',
          width: 180,
          slots: { title: 'reportDate' }
        },
        {
          title: '车场名称',
          dataIndex: 'parkName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse' }
        },
        {
          // title: '利用率',
          dataIndex: 'utilization',
          width: 180,
          slots: { title: 'turnOver' },
          customRender: v => {
            if (v === '') {
              return '--';
            } else {
              return v + '%';
            }
          }
        },
        {
          title: '停车总时长',
          dataIndex: 'parkingTime',
          width: 160
        },
        {
          title: '车位总数',
          dataIndex: 'totalSpaceAmount',
          width: 160
        }
      ];
    } else {
      return [
        {
          title: '序号',
          width: 120,
          customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
        },
        {
          // title: '日期',
          dataIndex: 'reportDate',
          width: 180,
          slots: { title: 'reportDate' }
        },
        {
          title: '车场名称',
          dataIndex: 'parkName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse' }
        },
        {
          // title: '利用率',
          dataIndex: 'utilization',
          width: 180,
          slots: { title: 'turnOver' },
          customRender: v => {
            if (v === '') {
              return '--';
            } else {
              return v + '%';
            }
          }
        },
        {
          title: '停车总时长',
          dataIndex: 'parkingTime',
          width: 160
        },
        {
          title: '车位总数',
          dataIndex: 'totalSpaceAmount',
          width: 160
        }
      ];
    }
  }
  // 日期、时段排序
  dateSortFn(type: string) {
    document.getElementsByClassName('caret-up')[0].classList.remove('active');
    document.getElementsByClassName('caret-down')[0].classList.remove('active');
    if (type === '00') {
      document.getElementsByClassName('caret-up')[0].classList.add('active');
    } else {
      document.getElementsByClassName('caret-down')[0].classList.add('active');
    }
    this.dateSort = type;
    this.current = 1;
    this.fetchTableData();
  }
  // 周转率排序
  turnOverSortFn(type: string) {
    document.getElementsByClassName('caret-up')[1].classList.remove('active');
    document.getElementsByClassName('caret-down')[1].classList.remove('active');
    if (type === '00') {
      document.getElementsByClassName('caret-up')[1].classList.add('active');
    } else {
      document.getElementsByClassName('caret-down')[1].classList.add('active');
    }
    this.utilizationSort = type;
    this.current = 1;
    this.fetchTableData();
  }
  search() {
    this.current = 1;
    this.fetchTableData();
    (this.$refs.chartRight as any).fetchRankData(1, this.selectParkIds);
  }
  clear({ defaultParkIdList }) {
    this.customTime = [];
    this.selectParkIds = [];
    this.timeRangeType = '01';
    this.dimensions = '01';
    this.dateSort = '01';
    this.utilizationSort = '01';
    document.getElementsByClassName('caret-up')[0].classList.remove('active');
    document.getElementsByClassName('caret-down')[0].classList.remove('active');
    document.getElementsByClassName('caret-up')[1].classList.remove('active');
    document.getElementsByClassName('caret-down')[1].classList.remove('active');
    this.pageSize = 10;
    this.onTimeRangeTypeChange();
    this.search();
  }
  getPopupContainer() {
    return this.$refs.panel['$el'];
  }

  onTimeRangeTypeChange() {
    this.current = 1;
    if (this.timeRangeType !== '03') {
      this.customTime = [];
      let startTime, endTime;
      if (this.dimensions === '00') {
        switch (this.timeRangeType) {
          case '01':
            // 今天
            startTime = moment().startOf('d');
            endTime = moment().endOf('d');
            break;
          case '02':
            // 昨天
            startTime = moment()
              .subtract(1, 'd')
              .startOf('d');
            endTime = moment()
              .subtract(1, 'd')
              .endOf('d');
            break;
        }
      } else {
        switch (this.timeRangeType) {
          case '01':
            // 近7天
            startTime = moment()
              .startOf('d')
              .subtract(7, 'd');
            endTime = moment()
              .endOf('d')
              .subtract(1, 'd');
            break;
          case '02':
            // 近1月
            startTime = moment()
              .subtract(1, 'd')
              .startOf('d')
              .subtract(1, 'month');
            endTime = moment()
              .subtract(1, 'd')
              .endOf('d');
            break;
          default:
            startTime = moment().startOf('d');
            endTime = moment().endOf('d');
        }
      }
      this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
      this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
      this.fetchTableData();
      this.$nextTick(() => {
        (this.$refs.chartRight as any).fetchRankData(1, this.selectParkIds);
      });
    }
  }
  //时间发生变化的回调
  onCustomTimeChange(date: any, dateString: any) {
    let [startTime, endTime] = date;
    console.log(date);
    this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
    this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
    this.search();
  }
  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      let param: any = {
        parkIds: this.selectParkIds.join(','),
        reportDateStart: this.filterParam.startTime,
        reportDateEnd: this.filterParam.endTime,
        dateSort: this.dateSort,
        utilizationSort: this.utilizationSort,
        reportType: this.dimensions,
        currPage: this.current,
        pageSize: this.pageSize
      };
      let res = await utilizationDetail(param);
      const data = res.data;
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        this.tableData = datas;
      }
      this.fetchChartData();
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  private async fetchChartData() {
    let param: any = {
      parkIds: this.selectParkIds.join(','),
      reportType: this.dimensions,
      reportDateStart: this.filterParam.startTime,
      reportDateEnd: this.filterParam.endTime
    };
    try {
      let res = await utilizationInfo(param);
      const data = res.data;
      if (data) {
        this.chartData = data.records;
        this.utilizationSum = data.utilizationSum;
      }
    } catch (e) {
      console.log(e);
    } finally {
      (this.$refs.chartLeft as any).refreshChart();
    }
  }

  created() {}

  @Watch('selectParkIds')
  onSelectParkIdChange() {
    this.current = 1;
    this.fetchTableData();
    (this.$refs.chartRight as any).fetchRankData(1, this.selectParkIds);
  }

  @Watch('dimensions', { immediate: true })
  onDimensionsChange(value: string) {
    if (value === '00') {
      this.timeQuickButtons = [{ value: '01', text: '今天' }, { value: '02', text: '昨天' }];
    } else {
      this.timeQuickButtons = [
        { value: '01', text: '近7天' },
        { value: '02', text: '近1月' },
        { value: '03', text: '自定义' }
      ];
    }
    this.timeRangeType = '01';
    this.onTimeRangeTypeChange();
    this.dateSort = '01';
    this.utilizationSort = '01';
    this.pageSize = 10;
  }
}
